<template>
  <div v-loading="loading">
    <el-form action="">
      <el-form-item label="是否开启分享">
        <el-radio-group v-model="status" @change="editSet">
          <el-radio label="1">开启</el-radio>
          <el-radio label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import ShareApi from "@/api/sharepolite.js";
export default {
  data() {
    return {
      loading: true,
      status: 1,
    };
  },
  created() {
    // 获取基本设置的值
    this.getSet();
  },
  methods: {
    getSet() {
      ShareApi.getset("", true).then((res) => {
        this.status = res.data.data.is_open;
        this.loading = false;
      });
    },
    editSet(value) {
      let params = { key: "sharePolite", is_open: value };
      ShareApi.set(params, true).then((res) => {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "success",
          duration:1500
        });
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/sharepolite/setting.vue